import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DatabaseOutlinedSvg from "@ant-design/icons-svg/es/asn/DatabaseOutlined";
import AntdIcon from "../components/AntdIcon";
var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DatabaseOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DatabaseOutlined.displayName = 'DatabaseOutlined';
}
export default /*#__PURE__*/React.forwardRef(DatabaseOutlined);